import { isFuture, parseISO } from 'date-fns';

export function usePresale() {
  const runtimeConfig = useRuntimeConfig();
  const { enabled, endDate } = runtimeConfig.public.presale ?? { enabled: false, endDate: '' };

  const isPresaleActive = computed(() => enabled && isFuture(endDate));

  return {
    isPresaleActive,
    endDate: readonly(parseISO(endDate)),
  };
}
